/**
 * FAQ accordion expand/collapse.
 */

export function initFaqAccordion(): void {
    const faqItems = document.querySelectorAll('[data-faq-item]');

    faqItems.forEach((item) => {
        const toggle = item.querySelector<HTMLButtonElement>('[data-faq-toggle]');
        const content = item.querySelector<HTMLElement>('[data-faq-content]');
        const icon = item.querySelector<HTMLElement>('[data-faq-icon]');

        if (!toggle || !content || !icon) {
            return;
        }

        const verticalLine = icon.querySelector<SVGLineElement>('[data-faq-vertical]');

        toggle.addEventListener('click', () => {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                toggle.setAttribute('aria-expanded', 'false');
                content.style.maxHeight = '0';
                if (verticalLine) {
                    verticalLine.style.opacity = '1';
                    verticalLine.style.transform = 'rotate(0deg)';
                }
                return;
            }

            toggle.setAttribute('aria-expanded', 'true');
            content.style.maxHeight = `${content.scrollHeight}px`;
            if (verticalLine) {
                verticalLine.style.opacity = '0';
                verticalLine.style.transform = 'rotate(90deg)';
            }
        });
    });
}
